import React from 'react';
import { Section } from './ui/Section';
export function SocialProofSection() {
  return <Section background="navy" data-id="element-345">
      <div className="text-center" data-id="element-346">
        <div className="text-5xl md:text-6xl font-extrabold text-[#e8a020] mb-3" data-id="element-347">
          87%
        </div>
        <h2 className="text-xl md:text-2xl font-bold text-white mb-4 leading-snug" data-id="element-348">
          de los padres hoy sienten que han perdido el control sobre el tiempo
          de pantalla de sus hijos 📈
        </h2>
        <p className="text-blue-100 text-sm md:text-base mb-6 leading-relaxed" data-id="element-349">
          No estás solo. Hemos diseñado este sistema basándonos en las{' '}
          <strong className="text-white" data-id="element-350">3 herramientas más efectivas</strong>{' '}
          recomendadas por expertos en crianza positiva para sustituir la
          dopamina digital por conexión humana real.
        </p>
        <div className="grid grid-cols-3 gap-4 max-w-sm mx-auto" data-id="element-351">
          <div className="bg-white/10 p-3 rounded-xl text-center" data-id="element-352">
            <div className="text-2xl font-extrabold text-[#e8a020]" data-id="element-353">30</div>
            <div className="text-blue-200 text-xs" data-id="element-354">días de plan</div>
          </div>
          <div className="bg-white/10 p-3 rounded-xl text-center" data-id="element-355">
            <div className="text-2xl font-extrabold text-[#e8a020]" data-id="element-356">4</div>
            <div className="text-blue-200 text-xs" data-id="element-357">recursos incluidos</div>
          </div>
          <div className="bg-white/10 p-3 rounded-xl text-center" data-id="element-358">
            <div className="text-2xl font-extrabold text-[#e8a020]" data-id="element-359">1–17</div>
            <div className="text-blue-200 text-xs" data-id="element-360">años de edad</div>
          </div>
        </div>
      </div>
    </Section>;
}